export enum NotificationType {
  FEE_PAYMENT_DUE = "FEE_PAYMENT_DUE",
  FEE_PAYMENT_OVERDUE = "FEE_PAYMENT_OVERDUE",
  FEE_PAYMENT_RECEIVED = "FEE_PAYMENT_RECEIVED",
  EVENT_UPCOMING = "EVENT_UPCOMING",
  EVENT_REMINDER = "EVENT_REMINDER",
  ASSIGNMENT_DUE = "ASSIGNMENT_DUE",
  LOW_ATTENDANCE_WARNING = "LOW_ATTENDANCE_WARNING",
  ABSENCE_ALERT = "ABSENCE_ALERT",
  GRADE_PUBLISHED = "GRADE_PUBLISHED",
  REPORT_CARD_AVAILABLE = "REPORT_CARD_AVAILABLE",
  PARENT_TEACHER_MEETING = "PARENT_TEACHER_MEETING",
  GENERAL_ANNOUNCEMENT = "GENERAL_ANNOUNCEMENT",
  SYSTEM_ALERT = "SYSTEM_ALERT",
  MAINTENANCE = "MAINTENANCE",
  PASSWORD_RESET = "PASSWORD_RESET",
  REMINDER = "REMINDER",
  WELCOME_MESSAGE = "WELCOME_MESSAGE",
}
